module.exports = "fragment PriceFragment on Price {\n  __typename\n  asString\n  currency\n  amount\n}\n"